export const en = {
  title: 'Tree cover',
  subtitle: '2000/2010, Hansen/UMD/Google/USGS/NASA',
  download_data: 'https://glad.umd.edu/dataset/global-2010-tree-cover-30-m',
  learn_more: 'http://science.sciencemag.org/content/342/6160/850',
  content: [
    {
      label: 'Function',
      value: 'Identifies areas of tree cover',
    },
    {
      label: 'Resolution',
      value: '30 × 30 meters',
    },
    {
      label: 'Geographic coverage',
      value: 'Global land (excluding Antarctica and Arctic islands)',
    },
    {
      label: 'Source',
      value:
        'Hansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available from: https://glad.umd.edu/dataset/global-2010-tree-cover-30-m.',
    },
    {
      label: 'Frequency',
      value: '',
    },
    {
      label: 'Date of content',
      value: '2000 & 2010',
    },
    {
      label: 'Cautions',
      value:
        'For the purpose of this study, “tree cover” was defined as all vegetation taller than 5 meters in height. “Tree cover” is the biophysical presence of trees and may take the form of natural forests or plantations existing over a range of canopy densities.',
    },
    {
      label: 'License',
      value: 'CC BY 4.0',
    },
  ],
  overview: {
    label: 'Overview',
    value:
      'This data set, a collaboration between the GLAD (Global Land Analysis & Discovery) lab at the University of Maryland, Google, USGS, and NASA, displays tree cover over all global land (except for Antarctica and a number of Arctic islands) for the years 2000 and 2010 at 30 × 30 meter resolution. “Percent tree cover” is defined as the density of tree canopy coverage of the land surface and is color-coded by density bracket (see legend).\n\nData in this layer were generated using multispectral satellite imagery from the Landsat 7 thematic mapper plus (ETM+) sensor. The clear surface observations from over 600,000 images were analyzed using Google Earth Engine, a cloud platform for earth observation and data analysis, to determine per pixel tree cover using a supervised learning algorithm.\n\nThe tree cover canopy density of the displayed data varies according to the selection - use the legend on the map to change the minimum tree cover canopy density threshold.',
  },
  citation: {
    label: 'Citation',
    value:
      'Use the following credit when these data are displayed:\nSource: Hansen/UMD/Google/USGS/NASA, accessed through Global Forest Watch\n\nUse the following credit when these data are cited:\nHansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available on-line from:https://glad.umd.edu/dataset/global-2010-tree-cover-30-m. Accessed through Global Forest Watch on 11/02/2025. www.globalforestwatch.org',
  },
};
